import React, { useState } from 'react';
import Pagination from '../../Common/Pagination';

export default function SiteDocList({ categoryKey = 0, documentList, onSelectDoc, viewDoc, downloadDoc, downloadAll }) {
    const numberFormatter = new Intl.NumberFormat('en-US', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const dateFormatter = new Intl.DateTimeFormat('en-US', { day: "2-digit", month: "2-digit", year: "numeric" });
    const [selectedPage, setSelectedPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    function handleSelectPage(pageNum) {
        setSelectedPage(pageNum);
    }

    let selectedCount = documentList.filter(doc => doc.selected).length;

    let shownDocumentList = documentList.slice((pageSize * selectedPage) - pageSize, (pageSize * selectedPage));

    let documentItems = shownDocumentList.length === 0 ? [(<li key="0"><div className="document"><span className="name">No Documents</span></div></li>)] :
        shownDocumentList.map(doc => {
            //const href = `https://api-prod.sw2.net/dl/${doc.guid}?version=${Date.now()}`;
            const href = `${doc.url}?version=${Date.now()}`;
            let viewBtn = (<button className="button" onClick={() => viewDoc(doc)}>View</button>);

            let downloadBtn = (<button className="button" onClick={() => downloadDoc(doc)}>Download</button>);
            if (selectedCount > 0) {
                downloadBtn = (<button className="button disabled">Download</button>);
            }

            let selectDoc = onSelectDoc && (<span className="select" onClick={() => onSelectDoc(categoryKey, doc.recordId)}>
                <i className={doc.selected ? "dhicon-check-2" : "dhicon-check-empty"} />
            </span>);

            //let fileName = doc.name, fileExtension, fileExtensionIndex = doc.name.lastIndexOf('.');
            //if (fileExtensionIndex > 0) {fileName = doc.name.substr(0, fileExtensionIndex); fileExtension = doc.name.substr(fileExtensionIndex); }

            return (<li key={`${doc.recordId}-${doc.attachmentId}`}>
                <div className="flexbox-flex-row-nowrap">
                    {selectDoc}
                    <div className="document" data-folder-id={categoryKey}>
                        <span className="date tabular-nums">{doc.createdAt ? dateFormatter.format(new Date(doc.createdAt)) : '-/-/-'}</span>
                        <span className="fileName">{doc.fileName}</span>
                        <div className="buttonContainer">
                            {downloadBtn}
                            {viewBtn}
                        </div>
                    </div>
                </div>
            </li>);
        });

    if (selectedPage > 1 && pageSize - documentItems.length > 0) {
        let emptyRows = Array.from(
            { length: pageSize - documentItems.length },
            (cv, i) => (<li className="noBkg" key={`R${i}`}><div className="buttonContainer"><button className="button hide">&nbsp;</button></div></li>));
        documentItems = documentItems.concat(emptyRows);
    }

    let downloadAllBtn = selectedCount > 0 && (<button className="button" onClick={() => downloadAll(categoryKey)}>Download</button>);

    return (<>
        <ul className="documentList mt-1">{documentItems}</ul>
        <Pagination itemCount={documentList.length} pageSize={pageSize} selectedPage={selectedPage} hideWhenSinglePage={false} onSelectPage={handleSelectPage}>
            {downloadAllBtn}
        </Pagination>
    </>);
}